import React from "react";
import { Box, Typography } from '@mui/material';
import { Global, css } from '@emotion/react';

/**
 * Full-screen processing screen with dynamic message
 * Used during image upload and model validation
 */
const ImageProcessingScreen = ({ message = "Uploading image...", subMessage = "This may take a few minutes" }) => {
  return (
    <div style={{ 
      width: "100%", 
      height: "100vh", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
      backgroundColor: "rgba(249, 252, 255, 1)"
    }}>
      <Global
        styles={css`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      />

      <Box
        sx={{
          background: "rgba(249, 252, 255, 1)",
          maxWidth: { xs: "90%", md: "40vw" },
          height: { xs: "auto", md: "12.5vh" },
          padding: { xs: "16px", md: "24px 36px" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: "center",
          textAlign: { xs: "center", md: "unset" },
          mx: { xs: "auto", md: 0 },
          border: "1px solid rgba(13, 30, 131, 0.1)",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }}
      >
        <Box sx={{ marginBottom: { xs: "16px", md: 0 }, marginRight: { xs: 0, md: "24px" } }}>
          <img 
            src="/assests/images/InferenceImage.svg" 
            style={{
              animation: 'spin 2s linear infinite',
              width: "64px",
              height: "64px"
            }} 
            alt="Processing Animation" 
          />
        </Box>
        <Box>
          <Typography fontWeight="500" fontSize={{ xs: "16px", md: "20px" }} sx={{ color: "#0D1E83", mb: 0.5 }}>
            {message}
          </Typography>
          <Typography fontWeight="400" fontSize={{ xs: "14px", md: "16px" }} sx={{ color: "#0D1E83", opacity: 0.7 }}>
            {subMessage}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default ImageProcessingScreen;

